export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-drag/src/constant.js
// module id = n5WD
// module chunks = 0